export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar pallet"])},
          "package_group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallet"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}